import { useLocation, useParams } from "react-router-dom";
import { MACHINES_URL } from "@/machines/routes";
import { useGetMachineById } from "@/machines/api/queries/machines.queries";

/**
 * Context-aware Export URL. On a location or machine page it prefills the
 * export scope via query params (`?location=…&machine=…`), mirroring the old
 * top-bar Export button so the export opens "predefined" for the current page.
 * Everywhere else it's the plain export route.
 */
export const useContextualExportHref = (): string => {
  const location = useLocation();
  const params = useParams();
  const { id: machineId } = params;
  const { data: machineData } = useGetMachineById(machineId);

  const queryParams = new URLSearchParams();

  // Location detail: /location/:id
  if (location.pathname.match(/^\/location\/\d+$/)) {
    if (params.id) queryParams.set("location", params.id);
  }
  // Machine detail: /machine/:id or /machine/live/:id
  else if (location.pathname.match(/^\/machine\/(live\/)?\d+$/)) {
    const machine = machineData?.data;
    if (machine) {
      if (machine.location?.id) {
        queryParams.set("location", machine.location.id.toString());
      }
      if (machine.device_mxid) {
        queryParams.set("machine", machine.device_mxid);
      }
    }
  }

  const qs = queryParams.toString();
  return qs ? `${MACHINES_URL.EXPORT}?${qs}` : MACHINES_URL.EXPORT;
};
